













































































































import { integer } from "vee-validate/dist/rules";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { receivedChecklistCollection } from "../../db";

@Component
export default class EquipmentReceivedChecklist extends Vue {
  @Getter checklistReceived;

  private search = "";
  private dialog = false;
  private formValid = false;
  private formEditMode = false;
  private form = {
    id: undefined,
    text: "",
    order: 0,
  };

  private headers = [
    { text: "Edit", value: "edit", sortable: false },
    { text: "Text", value: "text" },
    { text: "Order", value: "order" },
    { text: "Delete", sortable: false, value: "delete" },
  ];

  private rules = {
    number: (x) => integer.validate(x) || "Number required",
  };

  async add() {
    await receivedChecklistCollection.add({
      text: this.form.text,
      order: this.form.order,
    });
    this.clearForm();
    this.dialog = false;
  }

  edit(item) {
    this.form = {
      id: item.id,
      text: item.text,
      order: item.order,
    };
    this.formEditMode = true;
    this.dialog = true;
  }

  async save() {
    await receivedChecklistCollection.doc(`${this.form.id}`).update({
      text: this.form.text,
      order: this.form.order,
    });
    this.dialog = false;
    this.formEditMode = false;
    this.clearForm();
  }

  async remove(item) {
    await receivedChecklistCollection.doc(`${item.id}`).delete();
  }

  clearForm() {
    this.form = {
      id: undefined,
      text: "",
      order: 0,
    };
  }

  close() {
    this.dialog = false;
    this.clearForm();
  }
}
